export default "__VITE_ASSET__4dPVRQrM__"